import React from "react";

const styles = {
    container: {
        maxWidth: 840,
        margin: "0 auto",
        padding: "32px 20px",
        lineHeight: 1.6,
        color: "#111827",
        fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, 'Apple Color Emoji','Segoe UI Emoji'",
    },
    h1: { fontSize: 28, fontWeight: 800, margin: "0 0 8px" },
    meta: { color: "#6B7280", marginBottom: 24 },
    hr: { border: 0, borderTop: "1px solid #E5E7EB", margin: "24px 0" },
    h2: { fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 8 },
    ul: { paddingLeft: 18, marginTop: 8, marginBottom: 8 },
    li: { margin: "6px 0" },
    small: { color: "#6B7280" },
    link: { color: "#2563EB", textDecoration: "none" },
};

const PrivacyPolicy = () => {
    return (
        <div style={styles.container}>
            <h1 style={styles.h1}>Privacy Policy for STI Team Management</h1>

            <p style={styles.meta}>Effective Date: November 7, 2025</p>

            <hr style={styles.hr} />

            <p>
                STI Team Management (“we”, “our”, or “us”) respects your privacy and is committed
                to protecting your personal data. This Privacy Policy explains how we
                collect, use, and protect your information when you use our mobile
                application (“App”) available on Android and iOS platforms.
            </p>

            <h2 style={styles.h2}>1. Information We Collect</h2>

            <ul style={styles.ul}>
                <li style={styles.li}>
                    <b>Account Information:</b> Username, email address, and password
                    (stored in a securely hashed form).
                </li>

                <li style={styles.li}>
                    <b>Location Data:</b> Collected only during check-in and check-out to
                    verify attendance and working hours.
                </li>

                <li style={styles.li}>
                    <b>IP Address:</b> Logged to confirm location accuracy and prevent
                    unauthorized access.
                </li>

                <li style={styles.li}>
                    <b>Device Information:</b> Used for app diagnostics and security
                    checks.
                </li>
            </ul>

            <p>
                We do <b>not</b> collect sensitive data such as payment details,
                contacts, or photos.
            </p>

            <h2 style={styles.h2}>2. How We Use Your Information</h2>

            <ul style={styles.ul}>
                <li style={styles.li}>Authenticate and manage user accounts.</li>

                <li style={styles.li}>
                    Record accurate check-in and check-out logs.
                </li>

                <li style={styles.li}>Prevent unauthorized access.</li>

                <li style={styles.li}>Improve app reliability and performance.</li>
            </ul>

            <h2 style={styles.h2}>3. Data Storage and Security</h2>

            <p>
                All user data is securely stored in a{" "}
                <b>PostgreSQL (pgAdmin-managed)</b> database on our private server.
                We use strong encryption, hashed passwords, HTTPS connections,
                and access control to protect your data.
            </p>

            <h2 style={styles.h2}>4. Third-Party Services</h2>

            <p>
                STI Team Management may use third-party tools such as NodeMailer
                (for sending account-related emails). All user data is securely
                stored in a PostgreSQL database, managed through pgAdmin on our
                private server. These services operate under strict security
                protocols and comply with applicable data protection standards.
            </p>

            <h2 style={styles.h2}>5. Account Deletion</h2>

            <p>
                You can delete your account anytime through the app’s{" "}
                <b>Sidemenu/Drawer → Delete Account</b> option. Once deleted:
            </p>

            <ul style={styles.ul}>
                <li style={styles.li}>
                    All personal data and logs are permanently erased.
                </li>

                <li style={styles.li}>
                    Your credentials are immediately invalidated.
                </li>

                <li style={styles.li}>
                    Backup data (if any) is removed within 30 days.
                </li>
            </ul>

            <p>
                For help, email us at{" "}
                <a
                    href="mailto:Assistenza@elmecelettronica.com"
                    style={styles.link}
                >
                    Assistenza@elmecelettronica.com
                </a>
                .
            </p>

            <h2 style={styles.h2}>6. Your Rights</h2>

            <ul style={styles.ul}>
                <li style={styles.li}>Access or correct your information.</li>

                <li style={styles.li}>
                    Request permanent deletion of your data.
                </li>

                <li style={styles.li}>
                    Turn off location access anytime in your phone settings.
                </li>
            </ul>

            <h2 style={styles.h2}>7. Children’s Privacy</h2>

            <p>
                STI Team Management is designed for users aged 16 and above.
                We do not knowingly collect information from children.
            </p>

            <h2 style={styles.h2}>8. Updates to This Policy</h2>

            <p>
                We may update this Privacy Policy from time to time. Updates will
                be reflected with a new “Effective Date.” Continued use of
                STI Team Management after updates constitutes acceptance of
                the new version.
            </p>

            <h2 style={styles.h2}>9. Contact Us</h2>

            <p>
                For privacy-related inquiries, contact us at{" "}
                <a
                    href="mailto:Assistenza@elmecelettronica.com"
                    style={styles.link}
                >
                    Assistenza@elmecelettronica.com
                </a>
                .
            </p>

            <hr style={styles.hr} />

            <p style={styles.small}>
                © 2025 STI Team Management. All rights reserved.
            </p>
        </div>
    );
};

export default PrivacyPolicy;